var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAqaUsercol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a3.9,3.9,0,0,1-1.92-.5L3.9,24.83A3.63,3.63,0,0,1,2,21.67V10.32A3.64,3.64,0,0,1,3.89,7.17L14.08,1.49A4,4,0,0,1,16,1a3.91,3.91,0,0,1,1.93.5L28.1,7.17A3.63,3.63,0,0,1,30,10.33V21.68a3.64,3.64,0,0,1-1.89,3.15L17.92,30.51A4,4,0,0,1,16,31Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a2.92,2.92,0,0,1,1.42.37l10.2,5.68A2.64,2.64,0,0,1,29,10.32V21.66A2.66,2.66,0,0,1,27.62,24L17.44,29.63A3,3,0,0,1,16,30a3,3,0,0,1-1.43-.37L4.37,24A2.64,2.64,0,0,1,3,21.68V10.34A2.66,2.66,0,0,1,4.38,8L14.56,2.37A3,3,0,0,1,16,2h0m0-2h0a4.93,4.93,0,0,0-2.4.62L3.41,6.3a4.62,4.62,0,0,0-2.41,4V21.68a4.62,4.62,0,0,0,2.41,4l10.18,5.68a5,5,0,0,0,4.82,0L28.59,25.7a4.62,4.62,0,0,0,2.41-4V10.32a4.62,4.62,0,0,0-2.41-4L18.41.62A4.93,4.93,0,0,0,16,0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9a3,3,0,1,1-3,3,3,3,0,0,1,3-3h0m0,14a7.23,7.23,0,0,1-6-3.18c0-2,4-3,6-3s6,1.07,6,3A7.23,7.23,0,0,1,16,23",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaUsercol);
export default __webpack_public_path__ + "static/media/AQA-Usercol.f42c6e06b4e878fa4bd7688434841b40.svg";
export { ForwardRef as ReactComponent };